import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { Configuration, GlobalPatientApi, PatientAvailability } from "../api/client-axios";
import { ApiError } from "../model/apiError";
import { PhoneValidation } from "../model/phoneValidationType";
import { Problem } from "../model/problem";
import { apiConfiguration } from "./server";
import { applyRejection } from "./thunkError";

export interface AddPatientState {
    phoneNumber: string,
    phoneValidation: PhoneValidation,
    patientAvailability?: PatientAvailability,
    status: "idle" | "loading" | "error" | "success" | "auth-error";
    error?: string | Problem;
    code?: number;
}


const initialAddPatientState: AddPatientState = {
    phoneNumber: "",
    phoneValidation: "",
    status: "idle",
    error: ""
}

export const setPatientPhoneNumber = createAction('addPatient/setPhoneNumber', (phoneNumber: string) => { return { payload: phoneNumber }; });
export const setPatientPhoneValidation = createAction('addPatient/setPhoneValidation', (phoneValidation: PhoneValidation) => { return { payload: phoneValidation }; });
export const clearAddPatientError = createAction('addPatient/clearError');
export const initAddPatientState = createAction('addPatient/initState');

export const checkPatientAvailability = createAsyncThunk<PatientAvailability, {organizationId: string, phoneNumber: string}, { rejectValue: ApiError }>('addPatient/checkPatientAvailability', async (args, thunkApi) => {
    try {
        const api = new GlobalPatientApi(apiConfiguration());
        const response = await api.apiV1AdministrationOrganizationOrganizationIdPatientsAvailableRawPhoneNumberGet(args.organizationId, args.phoneNumber);
        return response.data;
    } catch (error: AxiosError | any) {
        return thunkApi.rejectWithValue({ message: error?.response?.data, statusCode: error?.response?.status });
    }
}); 


const addPatientSlice = createSlice({
    name: 'addPatient',
    initialState: initialAddPatientState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(checkPatientAvailability.pending, (state, _) => {
                state.status = "loading";
            })
            .addCase(checkPatientAvailability.fulfilled, (state, action) => {
                state.patientAvailability = action.payload;
                state.status = "success";
            })
            .addCase(checkPatientAvailability.rejected, (state, action) => {
                applyRejection(state, action);
            })
            .addCase(setPatientPhoneNumber, (state, action) => {
                state.status = "idle";
                state.phoneNumber = action.payload;
            })
            .addCase(setPatientPhoneValidation, (state, action) => {
                state.status = "idle";
                state.phoneValidation = action.payload;
            })
            .addCase(clearAddPatientError, (state, _) => {
                state.status = "idle";
            })
            .addCase(initAddPatientState, (state, _) => {
                state.phoneNumber ="";
                state.phoneValidation = "";
                state.status = "idle";
                state.error = "";
            });

           

    }
});

export default addPatientSlice.reducer;
